import React from "react";
import {
    NoCoverage,
    Gov,
    Private,
    SummaryPrivateNotReturned,
    FA,
    Curae,
    Simple,
    CardToDetailedTabbedResult,
    MedicareDetailedTabbedResult,
} from "@coverme/cards";
import "./InterviewCoverageSummary.scss";
import { Tooltip } from "../Tooltips/Tooltip";
import { ContentDropdown, TooltipTrigger, TooltipMessage } from "@coverme/elements";
import { Icon } from "@coverme/icons";
import { jsonContainErrors, getJsonErrors, formatDisplayDates } from "../../services/coverageService";
import { HealthBenefitPlanCoverage } from "../../containers/InterviewWizard/InterviewCoverage/HealthBenfitPlanCoverage";
import { InterviewInternalCoverageCard } from "./InterviewInternalCoverageCard";

export const InterviewCoverageCard = ({
    customerId,
    encounterId,
    coverage,
    thePatient,
    title,
    forFacesheet = false,
    ...props
}) => {
    let cards = [];
    console.log({ forFacesheet });
    if (
        coverage &&
        ((coverage.coverageSource && coverage.coverageSummary && coverage.coverageSummary?.personCoverages) ||
            coverage.coverageSummary?.personCoverages?.length > 0)
    ) {
        cards = coverage.coverageSummary.personCoverages
            .filter(x => x.coverageSource?.name !== "Interview" && x.isActive)
            .map(x => {
                if (x.coverageJson && jsonContainErrors(JSON.parse(x.coverageJson))) {
                    return (
                        <ContentDropdown
                            title={title}
                            subtitle={""}
                            estimatedHeight={cards?.length == 0 ? 300 : 800}
                            isOpenByDefault={true}
                        >
                            <div
                                style={{
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                    fontSize: "1.6em",
                                }}
                            >
                                <CardToDetailedTabbedResult
                                    card={
                                        <div className="facesheet-coverage-card facesheet-coverage-gov">
                                            <p className="facesheet-coverage-card__title">
                                                Summary is not currently available
                                            </p>
                                            <div className="facesheet-coverage-gov__container">
                                                <div className="facesheet-coverage-gov__info">
                                                    Check details tab for more information
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    json={getJsonErrors(JSON.parse(x.coverageJson)).validationMessages}
                                    key={x.GlobalId}
                                />
                            </div>
                        </ContentDropdown>
                    );
                }
                if (x.coverageJson) {
                    return (
                        <HealthBenefitPlanCoverage
                            customerId={customerId}
                            encounterId={encounterId}
                            coverageJson={x.coverageJson}
                            forFacesheet={forFacesheet}
                        />
                    );
                } else {
                    return (
                        <div>
                            <div className="coverage_header">Coverage Results
                                <div className="tool_tip_style">

                                    <Tooltip>
                                        <TooltipTrigger>
                                            <Icon icon={"tooltip"} color={"black"} height={20} width={20} />
                                        </TooltipTrigger>
                                        <TooltipMessage>
                                                                <p>Displays key information about a patient’s verified primary and supplemental coverage.</p>

                                        </TooltipMessage>
                                    </Tooltip>

                                </div>
                            </div>
                            <div className={forFacesheet === true ? `facesheet_summary_final_box` : `summary_box`}>
                                <div className="title_inside_box">Summary</div>
                                <InterviewInternalCoverageCard coverage={x}></InterviewInternalCoverageCard>
                            </div>
                        </div>
                    );
                }
            });
    }

    return (
        <>
            {cards?.length > 0 && <>{cards}</>}
            {cards?.length == 0 && (
                <ContentDropdown title={title} subtitle={""} estimatedHeight={`250`} isOpenByDefault={true}>
                    <div
                        style={{
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: "1.6em",
                        }}
                    >
                        <NoCoverage
                            title={"No Health Coverage Found"}
                            subtitle={`Available information suggests that ${thePatient} has no current insurance.`}
                        />
                    </div>
                </ContentDropdown>
            )}
        </>
    );
};
